
const g = {

  el: {
    // components
    accordions: document.querySelectorAll(".accordion") as NodeListOf<HTMLElement>,
    charts: document.querySelectorAll(".charts") as NodeListOf<HTMLElement>,
    contactForm: document.querySelector(".assistance__form form") as HTMLElement,
    details: document.querySelectorAll(".details") as NodeListOf<HTMLElement>,
    // filters: document.querySelectorAll("[data-filter]") as NodeListOf<HTMLInputElement>,
    formFields: document.querySelectorAll(".fieldset input[type=text], .fieldset input[type=email], .fieldset input[type=password], .fieldset select, .fieldset textarea") as NodeListOf<HTMLElement>,
    filters: document.querySelector(".filters") as HTMLElement,
    heroes: document.querySelectorAll(".hero") as NodeListOf<HTMLElement>,
    numbers: document.querySelectorAll(".numbers") as NodeListOf<HTMLElement>,
    offers: {
      container: document.querySelector(".offers") as HTMLElement,
      items: document.querySelectorAll(".offer") as NodeListOf<HTMLElement>,
    },
    uploadNavigation: document.querySelector(".upload__navigation") as HTMLElement,
    // layout
    cookies: document.querySelector(".cookies") as HTMLElement,
    header: document.querySelector(".header") as HTMLElement,
    layout: document.querySelector(".layout") as HTMLElement,
    lazyImages: document.querySelectorAll("[data-image-lazy]") as NodeListOf<HTMLElement>,
    loader: {
      content: document.querySelector(".loader__content") as HTMLElement,
      layoutWhite: document.querySelector(".loader__layout--white") as HTMLElement,
      layoutGreen: document.querySelector(".loader__layout--green") as HTMLElement,
    },
    navigation: {
      links: document.querySelectorAll("a:not([target=\"_blank\"]):not([href=\"#\"]):not([href*=\"mailto:\"]):not([href*=\"tel:\"])") as NodeListOf<HTMLElement>,
      trigger: document.querySelector(".header__navigation-trigger") as HTMLElement,
    },
  },

  resolution: {
    xs: 370,
    s: 576,
    m: 775,
    l: 992,
    xl: 1125,
    xxl: 1300,
    xxxl: 1700,
  },

  scroll: null,
};

export default g;
